import * as React from 'react'

const SkipForNow = () => (<a className="skip-for-now focus-on-light" href="/finish_sign_up">Skip for now</a>)

export default SkipForNow
